import type { ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';

import { ButtonBase } from '#src/atoms/buttons/ButtonBase/index.tsx';
import { Vertical } from '#src/atoms/layout/flex/index.tsx';
import type { CreateFiatWalletSteps } from '#src/components/fiatWallet/CreateFiatWallet/type.ts';
import { useBackButtonTargets } from '#src/components/fiatWallet/CreateFiatWallet/useBackButtonTargets.ts';
import { glossary } from '#src/lib/glossary.ts';

type StepWrapperFromPropsProps = {
  children: ReactNode;
  onBack?: () => void;
  submitButton: ReactNode;
};

export const StepWrapperFromProps = ({
  children,
  onBack,
  submitButton,
}: StepWrapperFromPropsProps) => {
  return (
    <Vertical className="min-h-full" gap={2}>
      {children}
      <div className="flex grow flex-row-reverse items-end justify-between">
        {submitButton}
        {!!onBack && (
          <ButtonBase className="underline" onClick={onBack}>
            <FormattedMessage {...glossary.back} />
          </ButtonBase>
        )}
      </div>
    </Vertical>
  );
};

type Props = {
  step: CreateFiatWalletSteps;
  setStep: (step: CreateFiatWalletSteps) => void;
} & Omit<StepWrapperFromPropsProps, 'onBack'>;

export const StepWrapper = ({
  children,
  step,
  setStep,
  submitButton,
}: Props) => {
  const backTargets = useBackButtonTargets({});
  const backTarget = backTargets[step];
  return (
    <StepWrapperFromProps
      submitButton={submitButton}
      onBack={
        backTarget
          ? () => {
              setStep(backTarget);
            }
          : undefined
      }
    >
      {children}
    </StepWrapperFromProps>
  );
};
